import React, { Component } from "react";
import { BrowserRouter } from "react-router-dom";
import { createStore } from "redux";
import { Provider } from "react-redux";
import rootReducer from "./store/reducers/rootReducer";

import Layout from "./containers/Layout/Layout";
import "./App.css";

class App extends Component {
 /*TODO: 2nd parameter has been added to debug Redux in the browser. It might be removed in future*/
 store = createStore(rootReducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

  render() {
    return (
      <Provider store={this.store}>
        <BrowserRouter basename={window.OPS_INSIGHTS.APPLICATION_NAME}>
          <Layout />
        </BrowserRouter>
      </Provider>
    );
  }
}

export default App;
